import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=c7acf164&"
import script from "./MenuButton.vue?vue&type=script&lang=ts&"
export * from "./MenuButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports